import type { IErrorMessage } from './ErrorMessage'

import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { FIXED_INDENTS } from 'vars/index'

export const ErrorMessageWrapperSC = styled.div<{
  position?: string
  zIndex?: number
}>`
  position: fixed;
  width: 100%;
  height: 100dvh;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: ${({ zIndex }) => (zIndex ? zIndex : '4')};
`

export const ErrorText = styled.div``

export const ErrorMessageSC = styled.div<
  Omit<IErrorMessage, 'title' | 'color' | 'position' | 'zIndex'> & {
    colorDefault: IErrorMessage['color']
  }
>`
  position: absolute;
  background: ${({ background }) =>
    background ? `var(${background})` : 'inherit'};
  width: ${({ width }) => (width ? width : '100%')};
  bottom: 0;
  left: 0;
  color: ${({ colorDefault }) =>
    colorDefault ? `var(${colorDefault})` : 'inherit'};

  & ${ErrorText} {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: ${({ paddings }) =>
      paddings?.map((padding) => (padding ? `var(${padding})` : 0)).join(' ') ||
      0};

    & ${IconSC} {
      order: ${({ iconPosition }) => (iconPosition === 'right' ? 1 : 0)};
      margin: ${({ iconPosition }) =>
        iconPosition === 'right'
          ? `0 0 0 var(${FIXED_INDENTS.INDENT_20})`
          : `0 var(${FIXED_INDENTS.INDENT_20}) 0 0`};
    }
  }
`
